var map = {
	"./adult.png": 71699,
	"./arrow-down.png": 99622,
	"./arrow-pointing-upper-left-corner.png": 42417,
	"./baby.png": 23761,
	"./ballot-1.png": 24117,
	"./ballot.png": 72547,
	"./bath.png": 80804,
	"./bed-double.png": 90305,
	"./bed-single.png": 71597,
	"./bill.png": 3876,
	"./blueprint.png": 6567,
	"./booking.png": 48090,
	"./books-stack.png": 10095,
	"./calendar.png": 43611,
	"./cell-phone.png": 72296,
	"./child.png": 2393,
	"./children.png": 71084,
	"./circle-bold.png": 91049,
	"./circle-fill-check.png": 41458,
	"./circle-fill-heartbeat.png": 69476,
	"./circle-fill-left-arrow.png": 39642,
	"./circle-fill-minus.png": 69159,
	"./circle-fill-plus.png": 17984,
	"./circle-fill.png": 81305,
	"./circle-minus.png": 17372,
	"./circle-plus.png": 74269,
	"./circle.png": 28877,
	"./clock.png": 65005,
	"./covid.png": 34011,
	"./credit-card.png": 47931,
	"./danger.png": 93523,
	"./date.png": 49387,
	"./disabled.png": 61367,
	"./doc.png": 84967,
	"./doctor.png": 28553,
	"./door.png": 78372,
	"./down-left-arrow.png": 83259,
	"./down-right-arrow.png": 97666,
	"./education-certificate.png": 53140,
	"./electrical-service.png": 49764,
	"./email-message-by-mobile-phone.png": 48190,
	"./email-symbol-on-laptop-screen.png": 70556,
	"./family.png": 70095,
	"./fan.png": 58104,
	"./floor.png": 72837,
	"./food.png": 41910,
	"./food2.png": 55781,
	"./full-size.png": 54953,
	"./guest.png": 73939,
	"./health-list.png": 10056,
	"./health-report.png": 80448,
	"./heart.png": 32036,
	"./heartbeat.png": 49526,
	"./hot-cup.png": 11055,
	"./hotel-1.png": 85368,
	"./hotel-2.png": 9813,
	"./hotel-3.png": 58480,
	"./hotel-receptionist.png": 40095,
	"./hotel.png": 82858,
	"./information.png": 57555,
	"./invoice.png": 83388,
	"./jacuzzi.png": 85240,
	"./key-1.png": 75246,
	"./key-room.png": 59862,
	"./key.png": 76164,
	"./kids.png": 45773,
	"./leaf.png": 94860,
	"./leafs.png": 22778,
	"./left-arrow-1.png": 14662,
	"./left-arrow-bold.png": 22028,
	"./left-arrow.png": 16567,
	"./license.png": 3075,
	"./luggage.png": 95089,
	"./man-in-suit.png": 96684,
	"./martini.png": 38744,
	"./martini2.png": 39001,
	"./massage.png": 23366,
	"./medic-female.png": 59218,
	"./medic-male.png": 45860,
	"./medical-file-1.png": 12486,
	"./medical-file.png": 31262,
	"./minibar.png": 4347,
	"./movie-with-students-audience.png": 88520,
	"./no-pets.png": 24063,
	"./no-smoke.png": 70699,
	"./nurse-woman.png": 65384,
	"./online-booking.png": 95856,
	"./online-course.png": 66754,
	"./open-book.png": 18829,
	"./patient-1.png": 40749,
	"./patient.png": 24614,
	"./persons.png": 88282,
	"./pool.png": 87935,
	"./presentation.png": 74493,
	"./receptionist.png": 62508,
	"./resume.png": 6144,
	"./right-arrow-1.png": 57469,
	"./right-arrow.png": 42384,
	"./right-straight-arrow.png": 4534,
	"./robe.png": 41402,
	"./ruble-1.png": 72334,
	"./ruble-circle-border-fill.png": 19789,
	"./ruble-circle-border.png": 8481,
	"./ruble-circle-fill.png": 34769,
	"./ruble-circle-underline-fill.png": 81217,
	"./ruble-circle-underline.png": 44582,
	"./ruble-circle.png": 49217,
	"./ruble.png": 19095,
	"./sauna.png": 98471,
	"./select-down.png": 14179,
	"./select-right.png": 22749,
	"./shower.png": 77022,
	"./size.png": 97834,
	"./sms-bubble-1.png": 80010,
	"./sms-bubble-2.png": 63104,
	"./sms.png": 1574,
	"./sofa.png": 36583,
	"./spa.png": 50350,
	"./speech-bubble.png": 2855,
	"./student-1.png": 86391,
	"./student-star-ribbon-shape.png": 82849,
	"./student-with-graduation-cap.png": 16969,
	"./student.png": 10187,
	"./taxi.png": 48874,
	"./test-quiz.png": 40427,
	"./towel.png": 85234,
	"./towel2.png": 69392,
	"./tv.png": 86478,
	"./two-united-arrows-in-straight-angle-pointing-left-and-down.png": 4589,
	"./upper-right-arrow.png": 17882,
	"./warning.png": 50966,
	"./watch.png": 27481,
	"./whatsapp.png": 36665,
	"./wifi.png": 6670,
	"./woman-call.png": 32169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16003;